var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9118 22.1246C7.3496 20.8013 5.90157 19.3505 4.58286 17.7874C2.60391 15.4402 0.253907 11.9444 0.253907 8.61321C0.253049 6.91196 0.760404 5.24869 1.71176 3.8339C2.66313 2.41911 4.01573 1.3164 5.59839 0.665317C7.18105 0.0142388 8.92262 -0.155939 10.6027 0.17632C12.2828 0.50858 13.8259 1.32834 15.0366 2.53186C15.8428 3.32886 16.4817 4.27671 16.9165 5.32058C17.3513 6.36444 17.5733 7.48357 17.5697 8.61321C17.5697 11.9444 15.2197 15.4402 13.2408 17.7874C11.922 19.3505 10.474 20.8013 8.9118 22.1246ZM8.9118 4.92829C7.92771 4.92829 6.98392 5.31652 6.28806 6.00758C5.59221 6.69863 5.20128 7.63591 5.20128 8.61321C5.20128 9.59052 5.59221 10.5278 6.28806 11.2188C6.98392 11.9099 7.92771 12.2981 8.9118 12.2981C9.8959 12.2981 10.8397 11.9099 11.5355 11.2188C12.2314 10.5278 12.6223 9.59052 12.6223 8.61321C12.6223 7.63591 12.2314 6.69863 11.5355 6.00758C10.8397 5.31652 9.8959 4.92829 8.9118 4.92829Z",
    fill: "url(#paint0_linear_205_3845)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_3845",
    x1: 8.91182,
    y1: 0.0107422,
    x2: 8.91182,
    y2: 22.1246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC371"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.8105493dbb3461f5934e57f70114448b.svg";
export { ForwardRef as ReactComponent };